import React from "react"
import { Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"

import { AppLinksBlock } from "@components"
import { dateFormatReceiver } from "@utils"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks"
import { selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"

export default function ReportListTableReadyBlock(
	{
		date,
		reportExecutionID,
		officeID,
		hasCompetitionSites,
		hasDirectSites,
		pickUp,
		noResults,
		hasGenerate,
		hasExport
	}) {
	const { reportType } = useReportBackendApiPath()
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING
	const isOneWay = selectedReportTypeTab.value === REPORT_TYPE_TABS.ONE_WAYS

	return <>
		<Typography variant="caption" sx={{ mb: 1 }}>
			{formatDate(date, {
				isString: true,
				format: 'dd MMM yyyy HH:mm',
				receivedFormat: dateFormatReceiver(date)
			})}
		</Typography>
		{!noResults && <AppLinksBlock
			downMultiReport={hasGenerate}
			downMultiExport={hasExport}
			hasCompetitionSites={hasCompetitionSites}
			hasDirectSites={hasDirectSites}
			reportExecutionID={reportExecutionID}
			officePickupID={officeID}
			pickUp={pickUp}
			showMatches={!reportType}
			isExtras={!!reportType}
			isRating={isRating}
			isOneWay={isOneWay}
		/>}
	</>
}